var app = angular.module('leonardo');

var FormSelectWrapper = function() {
  return {
    restrict: 'A',
    transclude: true,
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      inline: '=',
      label: '@'
    },
    templateUrl: 'views/templates/form/form-select-wrapper.html',
    link: function (scope, element, attrs) {
      scope.name = element.find('select').attr('name');
      scope.Form = scope.$parent.Form ? scope.$parent.Form : { '$submitted' : true };
    }
  };
};

app.directive('formSelectWrapper', [FormSelectWrapper]);
